import { useAdminUI } from "./AdminUIContext";
import styles from "./AdminShared.module.css";

const AdminToast = () => {
  const { toasts, dismissToast } = useAdminUI();

  if (!toasts.length) return null;

  return (
    <div className={styles["toast-stack"]} aria-live="polite">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`${styles.toast} ${styles[`toast-${t.type}`]}`}
          role="status"
        >
          <div className={styles["toast-body"]}>
            {t.title && <strong className={styles["toast-title"]}>{t.title}</strong>}
            <p className={styles["toast-message"]}>{t.message}</p>
          </div>
          <button
            type="button"
            className={styles["toast-dismiss"]}
            onClick={() => dismissToast(t.id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AdminToast;
